<template>
    <div>
      <loading
        :active.sync="loader.isLoading"
        :can-cancel="loader.canCancel"
        :is-full-page="loader.fullPage"
        :color="loader.color"
        :height="loader.height"
        :width="loader.width"
        :background-color="loader.backgroundColor"
        :loader="loader.loader">
      </loading>
      <div class="row">
        <div class="col-md-12">
            <div class="top-list-small-toolbar">
                <div>
                    <h4 class="text-primary">Neraca</h4>
                    <div class="form-inline">
                        <div class="button-group">
                            <span><b>Company:</b> </span>
                            <select v-model="company_no" class="btn btn-sm btn-soft-outline-primary">
                              <option value="">-- All --</option>
                              <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                            </select>
                        </div>
                        <div class="button-group ml-1">
                            <span class="mr-1"><b>Date:</b> </span>
                            <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                        </div>
                        <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshList">
                            <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                        </button>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="text-center" style="margin-top: 100px">
            <h5>Neraca</h5>
            <h5>{{ companyData.name }}</h5>
            <h5>{{ companyData.address }}</h5>
          </div>
          <div class="card" style="margin-top: 100px;">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <table class="table table-item mb-0 table-sm table-striped table-hover">
                            <tbody>
                                <tr v-for="a in account" :key="a.id">
                                    <!-- column 1 -->
                                    <td v-if="a.hierarcy==4">
                                      <span v-if="a.hierarcy==4" class="ml-5"><b class="font-14">{{ a.code }} {{ a.name }}</b></span>
                                    </td>
                                    <td v-else-if="a.hierarcy==5" style="background-color: black; color: white;">
                                        <span class="ml-5"><b class="font-14">{{ a.code }} {{ a.name }}</b></span>
                                    </td>
                                    <td v-else>
                                      <span v-if="a.hierarcy==1"><b>{{ a.code }} {{ a.name }}</b></span>
                                      <span v-else-if="a.hierarcy==2" class="ml-3"><b>{{ a.code }} {{ a.name }}</b></span>
                                      <span v-else-if="a.hierarcy==3" class="ml-30"><b>[{{ a.code }}]</b> {{ a.name }}</span>
                                    </td>
                                    <!-- End column 1 -->

                                    <!-- column 2 -->
                                    <td v-if="a.hierarcy==4"></td>
                                    <td v-else-if="a.hierarcy==5" style="background-color: black; color: white;"></td>
                                    <td class="text-right" v-else><span v-show="a.hierarcy == 2">{{ a.total }}</span></td>
                                    <!-- End column 2 -->

                                    <!-- column 3 -->
                                    <td class="text-right" v-if="a.hierarcy==4"><span v-show="a.hierarcy == 4"><b>{{ a.total }}</b></span></td>
                                    <td class="text-right" v-else-if="a.hierarcy==5" style="background-color: black; color: white;"><span v-show="a.hierarcy == 5"><b>{{ a.total }}</b></span></td>
                                    <td class="text-right" v-else><span v-show="a.hierarcy == 3"><b>{{ a.total }}</b></span></td>
                                    <!-- End column 3 -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <pre>{{ account }}</pre>
    </div>
</template>
<script>
import Axios from 'axios'
import { financeUrl, getHeader } from '@/config'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapState } from 'vuex'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'NeracaSimple',
  components: {
    Loading,
    DatePicker
  },
  computed: {
    ...mapState({
      companyList: state => state.companies.companyList
    }),
    companyData () {
      var obj = {
        name: null,
        address: null
      }
      const cmp = this.companyList.find(d => d.company_no === this.company_no)
      if (cmp) {
        obj = {
          name: cmp.name,
          address: cmp.address
        }
      }
      return obj
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    if (window.localStorage.getItem('authUser')) {
      const authU = window.localStorage.getItem('authUser')
      const auth = JSON.parse(authU)
      console.log('auth session')
      console.log(auth)
      this.company_no = auth.user.company_no
    }
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      company_no: '',
      startDate: [date1, date2],
      begin: new Date(),
      end: new Date(),
      contact: null,
      month: date.getMonth() + 1,
      year: date.getFullYear(),
      saldoAwal: 0,
      saldoAkhir: null,
      totalLabaRugi: null,
      account: [{
        id: null,
        hierarcy: null,
        parent_code: null,
        code: null,
        name: null,
        notes: null,
        account_balance: null,
        method: null,
        group_id: null,
        total: null
      }],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  methods: {
    editJournal: function (id) {
      alert(id)
    },
    refreshList: function () {
      this.$Progress.start()
      this.loader.isLoading = true
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = financeUrl + '/neraca-simple?date=' + end + '&company=' + this.company_no
      console.log(url)
      Axios.get(url, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.account = response.data.data
          this.totalLabaRugi = response.data.totalLabaRugi
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    }
  }
}
</script>

<style scoped>
  .first-col {
    position: absolute;
    width: 5em;
    margin-left: -5em;
  }
</style>
